module.exports = {
  DOCUMENTS_COLLECTION: 'documents',
  ASSETS_COLLECTION: 'assets',
  METADATA_COLLECTION: 'metadata',
  SNOOTY_STITCH_ID: 'snooty-koueq',
  BRANCHES_COLLECTION: 'repos_branches',
};
